import { Impulse, useScoped } from "~/tools/impulse";

/**
 * This impulse holds whether dropdown menu is enabled in the application.
 * It is initially false to avoid loading the heavy `@radix-ui/react-dropdown-menu` library
 * until the user hovers of focuses a dropdown menu trigger.
 */
const isEnabled = Impulse(false);

export function useIsEnabled(): boolean {
	return useScoped((scope) => isEnabled.getValue(scope), []);
}

export function enable(): void {
	isEnabled.setValue(true);
}
